export class UserModel {

    public id: string;
    public login: string;
    public email: string;
    public firstName: string;
    public lastName: string;
    public middleName: string;

    public registrationDate: string;
    public lastActivityDate: string;
    public role: number;
    public status: number;
    public isDeleted: boolean;
    
    public greeting: string;
    public avatar: string;

    public isChecked: boolean;

    public get fullName() {
        if (this.firstName && this.lastName) {
            return this.firstName + " " + this.lastName;
        }

        return "Unidentified Raccoon";
    }
    public accessKeys: string[];

    public telegramId: number;
}



// WEBPACK FOOTER //
// ./src/app/core/models/user.model.ts